import { Box } from '@mui/material';
import { PythonFunctionSummary } from 'api/model';
import ScopeIndicator from 'components/indicators/ScopeIndicator';

type PythonFunctionRendererProps = {
  pythonFunction?: PythonFunctionSummary;
  fallback: string;
};

const PythonFunctionRenderer = ({ pythonFunction, fallback }: PythonFunctionRendererProps) => {
  if (!pythonFunction) return <span>{fallback}</span>;

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" gap={1}>
      <span>{pythonFunction.name}</span>
      <ScopeIndicator isGlobal={pythonFunction.project_id == null} />
    </Box>
  );
};

export default PythonFunctionRenderer;
